import Dexie, { Table } from 'dexie';
import { ReceivedScoreBaseModel } from 'API/Generated/data-contracts';

export type OfflineSyncStatus = 'pending' | 'synced' | 'failed';

export interface OfflineScoreRecord {
  id: string;

  pageantId: number;
  eventId: number;
  eventJudgeId: number;

  registeredPageantContestantId: number;
  aocScoreCategoryId: number;

  score: number;
  notes?: string | null;

  syncStatus: OfflineSyncStatus;
  syncAttempts: number;
  lastSyncAttemptAt?: number | null;
  lastSyncError?: string | null;

  createdAt: number;
  updatedAt: number;

  raw: ReceivedScoreBaseModel;
}

export interface OfflineJudgePortalSnapshotRecord {
  id: string;
  snapshot: unknown;
  updatedAt: number;
}

export interface OfflineJudgeSessionRecord {
  id: string;
  eventJudgeId: number;
  eventId: number;
  judgeName: string;
  judgeLabel?: string | null;
  accessCode: string;
  pageantId: number;
  cachedAt: number;
  status?: string;
}

class JudgeOfflineDb extends Dexie {
  scores!: Table<OfflineScoreRecord, string>;

  judgePortalSnapshots!: Table<
    OfflineJudgePortalSnapshotRecord,
    string
  >;

  judgeSessions!: Table<OfflineJudgeSessionRecord, string>;

  constructor() {
    super('HelloTiaraJudgeOfflineDb');

    // VERSION 1
    this.version(1).stores({
      scores:
        'id, pageantId, eventId, eventJudgeId, registeredPageantContestantId, aocScoreCategoryId, syncStatus, updatedAt',
    });

    // VERSION 2
    this.version(2).stores({
      scores:
        'id, pageantId, eventId, eventJudgeId, registeredPageantContestantId, aocScoreCategoryId, syncStatus, updatedAt',

      judgePortalSnapshots: 'id, updatedAt',
    });

    this.version(3).stores({
  scores:
    'id, pageantId, eventId, eventJudgeId, registeredPageantContestantId, aocScoreCategoryId, syncStatus, updatedAt',
  judgePortalSnapshots: 'id, updatedAt',
  judgeSessions: 'id, accessCode, eventJudgeId, eventId, pageantId, cachedAt, status',
});
  }
}

export const judgeOfflineDb = new JudgeOfflineDb();

export const buildOfflineScoreId = (params: {
  eventJudgeId: number;
  registeredPageantContestantId: number;
  aocScoreCategoryId: number;
}): string => {
  return [
    params.eventJudgeId,
    params.registeredPageantContestantId,
    params.aocScoreCategoryId,
  ].join('|');
};